export enum EmptyStateDataHooks {
  Main = 'empty-state-container',
  EmptyStateTitle = 'empty-state-title',
  EmptyStateSubTitle = 'empty-state-title-sub-title',
}
